var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFavouriteStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.811 24.023"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.406.847a.535.535 0 011 0l2.709 7.679h7.647a.535.535 0 01.348.941l-6.39 5.3 2.674 8.034a.535.535 0 01-.824.6l-6.665-4.89-6.672 4.885a.535.535 0 01-.821-.6l2.674-8.034-6.391-5.3a.535.535 0 01.348-.941h7.648z"
  })));
}

export default __webpack_public_path__ + "d797647f7a057d0c84e7816d00dfd6b5.svg";
export { SvgFavouriteStar as ReactComponent };